export default "__VITE_ASSET__GbQRS3pF__"